// 检查当前登录的账号是否有变化
// 有用户同时开启多窗口，在新的窗口切换了其他账号，此时再回到老窗口会出现各种权限与数据不符的情况
// 遇到这种情况 就提示用户刷新页面
import { MessageBox } from 'element-ui';

// 记录当前的cookie 和 每次请求的cookie对比 如果cokkie不符 证明用户在其他窗口重新登陆嘞账号 此时需要重置视角相关的本地数据
let initCookie = CookiesTools.getToken();
let hasCookieAlert = false;
document.addEventListener('visibilitychange', function () {
	if (!document.hidden) {
		const cookie = CookiesTools.getToken();
		if (initCookie && cookie && initCookie != cookie && !hasCookieAlert && !['/login'].includes(location.pathname)) {
			hasCookieAlert = true;
			sessionStorage.removeItem('vuex_dataViewId');
			MessageBox.alert('检测到在其他窗口已登录新的账号(如需登录多账号请使用多浏览器)，请重新刷新页面', '提示', {
				confirmButtonText: '知道了',
				callback: () => {
					location.reload();
				},
			});
		}
	}
});

export const checkAccount = (cookie, config) => {
	if (
		initCookie &&
		cookie &&
		initCookie != cookie &&
		!hasCookieAlert &&
		!['/login'].includes(location.pathname) &&
		config.url != '/api/account/logout'
	) {
		hasCookieAlert = true;
		sessionStorage.removeItem('vuex_dataViewId');
		MessageBox.alert('检测到在其他窗口已登录新的账号(如需登录多账号请使用多浏览器)，请重新刷新页面', '提示', {
			confirmButtonText: '知道了',
			callback: () => {
				location.reload();
			},
		});
	}
};

export const resetCookie = cookie => {
	initCookie = cookie;
};
